import { Pipe, PipeTransform } from '@angular/core';
import { FilterListModel, FilterSubsListObj } from 'src/app/models/filter-list-model';

@Pipe({
  name: 'filterListSepration'
})
export class FilterListSeprationPipe implements PipeTransform {

  transform(filterOption: Array<any>, genelist: Array<any>, filterKey: any, type: string = "", ): Array<FilterSubsListObj> | [] {
    let finalFilterlist: Array<any> = filterOption;
    if (type === "playlist" && filterKey === "genres") {
      let geneFilteList: any = [];
      genelist.map(genereObj => {
      let found: any = filterOption.find(item => item.key ===  genereObj);
        if (found) {
          geneFilteList.push(found)
        }
      })
      finalFilterlist = geneFilteList
    }

    return finalFilterlist;
  }

}
